/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DragHandle/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconDrag from 'DesignSystem/Svgs/TysiaIconDrag/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DragHandle({
  children,
  disabled,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/DragHandle"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="DragHandle.Vertical"
  data-view-path={viewPath}
 style={{'--d-1-izJqk': disabled ? "none" : "flex"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconDrag
  viewPath={`${viewPath}/TysiaIconDrag`}
 fill2={dtColorsNeutral400}
 height={14}
 width={14}
/>
</div>
{children}
</React.Fragment>)
}